declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: {
      suppressGlobalErrorToast?: boolean;
    };
  }
}

export type HttpQueryError = Error & {
  status?: number;
  statusText?: string;
};

export const managedPageQueryMeta = {
  suppressGlobalErrorToast: true,
} as const;

export const createHttpQueryError = (status: number, statusText: string, message: string): HttpQueryError => {
  const error = new Error(message) as HttpQueryError;
  error.status = status;
  error.statusText = statusText;
  return error;
};

export const throwIfResponseNotOk = (response: Response, clientErrorMessage: string): void => {
  if (response.ok) {
    return;
  }

  const message =
    response.status > 499 ? `Applicatiefout ${response.status}: ${response.statusText}` : clientErrorMessage;
  throw createHttpQueryError(response.status, response.statusText, message);
};

export const getHttpStatusFromError = (error: unknown): number | null => {
  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return null;
  }

  const status = (error as { status?: unknown }).status;
  return typeof status === 'number' ? status : null;
};
